import React, { useRef } from "react";
import './index.css'
import Webcam from "react-webcam";
import { useGetGoldebBallInfo } from "./hooks/useGetGoldenBallInfo";
import { useScrollPage } from "../ChampionsThrophyScreen/hooks/useScrollPage";
import { motion } from 'framer-motion';
import FireworksCanvas from "../../components/FireworkComponent";

const GoldenBallThrophyScreen = ()=>{
        const webcamRef = useRef(null)
        const heightFromHeader = document.getElementsByClassName('talacha-header')?.[0]?.offsetHeight
        const { goldenBallInfo } = useGetGoldebBallInfo()
        useScrollPage(heightFromHeader) 
return(
        <div className="container-golden-ball-screen">
        <Webcam
         audio={false}
        mirrored
        screenshotFormat="image/jpeg"
        className="webcam"
          width={1000}
         height={600}
         ref={webcamRef}
           />
         <FireworksCanvas setup={{
            particles: 200,
            explosion: 3,
            intensity:20
        }} />

        <div className="container-goldeb-ball-banner-name">
            
                <motion.p
                animate={{
    filter: [
      "drop-shadow(0 0 0px gold)",
      "drop-shadow(0 0 25px gold)",
      "drop-shadow(0 0 0px gold)",
    ],
        opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }}
                >Cesar Adrian Vallejo</motion.p>
            </div>

            <div className="container-golden-ball-screen-img-card"
            >
          
           <motion.img 
                 animate={{
    filter: [
      "drop-shadow(0 0 0px white)",
      "drop-shadow(0 0 25px white)",
      "drop-shadow(0 0 0px white)",
    ],
        opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }}
           
           width={250} height={400}  src={goldenBallInfo?.goldenBallImg} />

                       

            </div>
            <div className="container-goldeb-ball-banner">
                <div>
                    <motion.img 
                     animate={{

    opacity: [1, 0.85, 1], // Opacidad: normal -> un poco transparente -> normal
    scale: [1, 1.03, 1]    // Escala: normal -> un 3% más grande -> normal
  }}
  transition={{ 
    duration: 2,       // Duración total de la secuencia (2 segundos)
    repeat: Infinity   // Repetir el ciclo sin fin
  }}
                    
                    width={40} height={40} src="https://res.cloudinary.com/djrzar6pz/image/upload/v1764139870/trofeosJR-logo-removebg-previewpng.png" />
                </div>
                <motion.p
                animate={{
    filter: [
      "drop-shadow(0 0 0px gold)",
      "drop-shadow(0 0 25px gold)",
      "drop-shadow(0 0 0px gold)",
    ],
        opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }}
                >Balon de Oro del Barril 2025</motion.p>
                 <motion.img 
                     animate={{

    opacity: [1, 0.85, 1], // Opacidad: normal -> un poco transparente -> normal
    scale: [1, 1.1, 1]    // Escala: normal -> un 3% más grande -> normal
  }}
  transition={{ 
    duration: 2,       
    repeat: Infinity   
    
  }}
                    
                    width={35} height={35} src="https://res.cloudinary.com/djrzar6pz/image/upload/v1765220671/copa-mariachi-mxpng.png" />
            </div>




        </div>
    )
}

export default GoldenBallThrophyScreen